import { Card, Spin } from '@firesoon/antd';
import { useSetState, useToggle } from 'ahooks';
import classNames from 'classnames';
import React, { useRef } from 'react';
import Extra from './Extra';
import './index.less';
import { IFullScreenCardProps } from './interface';

const Index = ({
  children,
  loading = false,
  hasFull = true,
  title = '',
  hasRadio = false, // 是否展示快捷切换
  extraRadioType = 'distributionTrend', // 快捷切换默认为分布趋势的切换
  extraRadios = null,
  customExtra = null,
  radioProps = {},
  cardProps = {},
  hideDownload = false,
  onDownload,
  isFull: propsIsFull,
  toggle: propsToggle,
  dataLogModule = '',
  fullLogValue = '放大',
}: IFullScreenCardProps) => {
  const { onChangeRadio, defaultType } = radioProps || ({} as any);
  const [{ childLoading }, setState] = useSetState({
    childLoading: false,
  });
  const [middleIsFull, { toggle: middleToggle }] = useToggle(false);
  const ref = useRef(null);

  // TODO 后续需要优化
  const isFull = propsIsFull ?? middleIsFull;
  const toggle = propsToggle ?? middleToggle;

  const toggleFull = () => {
    setState({
      childLoading: true,
    });
    toggle?.();

    setTimeout(() => {
      setState({
        childLoading: false,
      });
    }, 300);
  };

  return (
    <div className={classNames('fs-full-screen', { 'fs-full-screen-wrap': isFull })} data-log-module={dataLogModule}>
      <Spin spinning={loading}>
        <Card
          title={title}
          bordered={false}
          extra={
            <Extra
              hasRadio={hasRadio}
              isFull={isFull}
              toggle={toggleFull}
              onChangeRadio={onChangeRadio}
              defaultType={defaultType}
              customExtra={customExtra}
              type={extraRadioType}
              extraRadios={extraRadios}
              hasFull={hasFull}
              hideDownload={hideDownload}
              download={() => onDownload?.(ref?.current)}
              fullLogValue={fullLogValue}
            />
          }
          {...cardProps}
        >
          <div style={{ height: '100%', padding: isFull ? 40 : 12 }} ref={ref}>
            {childLoading ? null : children}
          </div>
        </Card>
      </Spin>
    </div>
  );
};

export default Index;
